export function createThrottler() {
  const timeouts = new Map<string, ReturnType<typeof setTimeout>>();

  return function throttle<T>(key: string, fn: () => Promise<T> | T, delay: number = 300): Promise<T | void> {
    if (!timeouts.has(key)) {
      timeouts.set(
        key,
        setTimeout(() => {
          timeouts.delete(key);
        }, delay),
      );

      return Promise.resolve(fn());
    }
    return Promise.resolve();
  };
}

export function createDebouncer() {
  const debounceState = new Map<
    string,
    {
      timeoutId: ReturnType<typeof setTimeout>;
      resolve: (value: any) => void;
      reject: (reason?: any) => void;
    }
  >();

  return function debounce<T>(key: string, fn: () => Promise<T> | T, delay: number = 300): Promise<T | void> {
    if (debounceState.has(key)) {
      const oldState = debounceState.get(key)!;
      clearTimeout(oldState.timeoutId);
      oldState.resolve(undefined);
    }

    return new Promise<T | void>((resolve, reject) => {
      const timeoutId = setTimeout(async () => {
        try {
          const result = await fn();
          resolve(result);
        } catch (error) {
          reject(error);
        } finally {
          debounceState.delete(key);
        }
      }, delay);

      debounceState.set(key, { timeoutId, resolve, reject });
    });
  };
}
